import { getOS } from '../../common/user-agent-helpers'
import { WindowsSupportBannerService } from '../../services/banner/windows-support-banner-service'
import { isWindowsContainer } from '../../services/container/helpers'

export const initializeWindowsSupportBanner = () => {
  const winSupportBannerService = new WindowsSupportBannerService()
  return canShowWindowsSupportBanner() ? winSupportBannerService.show() : winSupportBannerService.hide()
}

/**
 * Verifies if the user is on a windows desktop version below than 10
 * @returns true/false
 */
const canShowWindowsSupportBanner = (): boolean => {
  const osMajorVersion = Number(getOS().major)
  return isWindowsContainer() && osMajorVersion < 10
}
